import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["action"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function setExperiencesForwarding(fromExperienceTracker, toExperienceTracker) {
  if (!fromExperienceTracker || !toExperienceTracker) {
    return;
  }
  var cancelExperiencesForwarding = fromExperienceTracker.subscribe(function (_ref) {
    var action = _ref.action,
      options = _objectWithoutProperties(_ref, _excluded);
    switch (action) {
      case 'taskAbort':
        toExperienceTracker.abort(_objectSpread(_objectSpread({}, options), {}, {
          checkForTimeout: false // disallow `taskAbort` to be converted into `taskFail`
        }));

        break;
      case 'taskFail':
        toExperienceTracker.fail(options);
        break;
      case 'taskStart':
        toExperienceTracker.start(options);
        break;
      case 'taskSuccess':
        toExperienceTracker.succeed(options);
        break;
    }
  });
  return cancelExperiencesForwarding;
}